export { default } from "./Recommend"
